import BreadCrumb from "../BreadCrumb";
import BankaItem from "./BankaItem";
import Photos from "../Blank/Photos";
import Faq from "../Blank/Faq";
import StaticPage from "./StaticPage";
import GetOffer from "./GetOffer";
import Advertise from "./Advertise";
import ReviewItem from "../Index/ReviewItem";

const SinglePaymentPage = dynamic(() => import("./SinglePaymentPage"), {
  ssr: false,
});
import Link from "next/link";
import Image from "next/image";
import Remote from "../LoaderRemote";
import styles from "../VillaItem.module.css";
import styles2 from "../../components/Detail/Photos.module.css";

import OwnerVerification from "./OwnerVerification";
import dynamic from "next/dynamic";

const Loading = () => {
  return (
    <div className={styles2.Photos}>
      <div className="w-full h-full relative"></div>
      <div className="w-full h-full relative"></div>
      <div className="w-full h-full relative"></div>
      <div className="w-full h-full relative"></div>
    </div>
  );
};
const Content = dynamic(() => import("../Detail/Photos/Content"), {
  loading: () => <Loading />,
});
const Blank = ({ ssr, action, isAppWebView }) => {
  const page = ssr.result;
  const comp = {
    StaticPage: StaticPage,
    GetOffer: GetOffer,
    Advertise: Advertise,
    SinglePayment: SinglePaymentPage,
    OwnerVerification: OwnerVerification,
  };
  const Component = comp[action];
  if (action != "Detail" && action != "BankAccounts" && action != "Reviews")
    return <Component ssr={ssr} isAppWebView={isAppWebView} />;

  return (
    <>
      <BreadCrumb data={ssr.result.BreadCrumb} isAppWebView={isAppWebView} />
      <div className="container mb-8">
        {page?.cat == "508" && (
          <>
            <div className="mb-5">
              <Content Images={page._photos} styles={styles2} />
            </div>
            {/* {page._photos.length > 0 && (
              <Fancybox options={{ infinite: false }}>
                <button
                  type="button"
                  className={`bg-brand-color-primary mx-auto text-white shadow-sm rounded-md text-sm px-2 py-1 lg:hidden`}
                  data-fancybox="galleryM"
                  data-src={
                    process.env.NEXT_PUBLIC_CDN +
                    "/uploads/" +
                    page._photos[0].Filename
                  }
                  data-thumb={
                    process.env.NEXT_PUBLIC_CDN +
                    "/uploads/150/" +
                    page._photos[0].Filename
                  }
                >
                  Tüm Fotoğraflar
                </button>
              </Fancybox>
            )} */}
          </>
        )}
        <div
          className="break-words"
          id="content"
          dangerouslySetInnerHTML={{ __html: page.icerik }}
        ></div>
        <div className="grid grid-cols-2 gap-2 lg:gap-5 lg:grid-cols-4">
          {page._pages &&
            page._pages.map((item, key) => (
              <div
                key={key}
                className="relative flex items-end justify-start w-full h-32 overflow-hidden text-left rounded-lg shadow-inner lg:h-96"
              >
                <Link href={item.url}>
                  <a
                    title={item.title}
                    className="pb-2 font-medium text-md group"
                  >
                    {item.resim && (
                      <Image
                        layout="fill"
                        src={item.resim}
                        objectFit={"cover"}
                        sizes="(max-width: 768px) 60vw,
                  25vw"
                        loader={Remote}
                        alt={item.title}
                      ></Image>
                    )}
                    <h2
                      className={
                        "z-10 px-2 lg:px-5 relative text-white font-bold text-sm mm:text-base lg:text-2xl transition-all duration-200 translate-y-0 lg:translate-y-4 group-hover:translate-y-0 " +
                        (action != "Destination" ? "lg:mb-4 " : "") +
                        styles.Ribbon
                      }
                    >
                      {item.baslik}
                    </h2>
                  </a>
                </Link>
              </div>
            ))}
        </div>
        {page?.cat != "508"
          ? page._photos && <Photos data={page._photos}></Photos>
          : ""}
        {page._faq && <Faq data={page._faq}></Faq>}
        {page._bankAccounts &&
          page._bankAccounts.map((item, key) => (
            <BankaItem key={key} item={item}></BankaItem>
          ))}
        {page._reviews && (
          <div className="flex flex-col gap-y-5">
            {page._reviews.map((item, key) => (
              <ReviewItem isReview={1} data={item} key={key} />
            ))}
          </div>
        )}
      </div>
      <div className="container mb-40"></div>
    </>
  );
};

export default Blank;
